module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_tvb_hanabi-f773346a70f6d6fcfbe0396541b43f03.jpg";